import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getData, putData } from "../../../../backend/api";
import { RowContainer } from "../../../styles/containers/styles";
import { useNavigate } from "react-router-dom";
import FormInput from "../../../elements/input";
import { Footer, Form } from "../../../elements/form/styles";
const CaseDeadlines = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = `${t("caseDeadlines")} - Whistleblowing24`;
  }, [t]);

  useEffect(() => {
    getCaseDeadlines();
  }, []);

  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const formInput = [
    {
      type: "number",
      placeholder: "autoOpenDaysPlaceholder",
      name: "autoOpenDays",
      validation: "",
      default: "",
      label: "autoOpenDays",
      required: true,
    },
    {
      type: "number",
      placeholder: "autoOpenDaysPlaceholder",
      name: "autoCloseDays",
      validation: "",
      default: "",
      label: "autoCloseDays",
      required: true,
    },
    
  ];

  const getCaseDeadlines = async () => {
    try {
        props.setLoaderBox(true);
        const response = await getData({}, `company/admin?id=${props.user.user.company}`, dispatch, navigate);
        if(response.status === 200){
            props.setLoaderBox(false);
            setFormValues({autoOpenDays: response?.data?.autoOpenDays??"" , autoCloseDays: response?.data?.autoCloseDays??""});
            setFormErrors({autoOpenDays: "" , autoCloseDays: ""});
        }
    } catch (error) {
        console.error("error", error);
    }
  }

  const validation = (fields, udpatedValue, formErrors, captchaStatus, useCaptcha, agreement, useCheckbox) => {
    const tempformErrors = { ...formErrors };
    let flags = 0;
    fields.forEach((item) => {
      if (item.name !== "_id") {
        if (item.type === "multiple") {
          item.forms.forEach((form, multipleIndex) => {
            form.forEach((inputs, index) => {
              const res = fieldValidation(inputs, typeof udpatedValue[item.name][multipleIndex][inputs.name] === "undefined" ? "" : udpatedValue[item.name][multipleIndex][inputs.name], udpatedValue);
              tempformErrors[item.name][multipleIndex][inputs.name] = res.tempformError;
              flags += res.flag; //?res.flag:0;
            });
          });
        } else {
          const res = fieldValidation(item, typeof udpatedValue[item.name] === "undefined" ? "" : udpatedValue[item.name], udpatedValue);
          tempformErrors[item.name] = res.tempformError;
          flags += res.flag; //?res.flag:0;
        }
      }
    });

    setFormErrors(tempformErrors);
    setSubmitDisabled(flags > 0 ? true : false);
    if (flags === 0) {
      return true;
    } else {
      return false;
    }
  };

  const fieldValidation = (field, value, udpatedValue) => {
    let flag = 0;
    let tempformError = "";

    if (!field.update && props.formType === "put") {
      return { flag, tempformError };
    }
    if (!field.required && value.length === 0) {
      return { flag, tempformError };
    }
    if (field.condition) {
      if (udpatedValue[field.condition.item] === field.condition.if) {
        if (field.condition.then === "disabled") {
          return { flag, tempformError };
        }
      } else {
        if (field.condition.else === "disabled") {
          return { flag, tempformError };
        }
      }
    }
    switch (field.validation) {
      case "email":
        const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        if (!regex.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
      case "passwordMatch":
        if (udpatedValue["newPassword"] !== udpatedValue["confirmPassword"]) {
          tempformError = t("passwordEqual");
          flag += 1;
        }
        break;
      case "fileNumber":
        const fileNumber = /[A-Z0-9-]/;
        if (!fileNumber.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
      case "licensePlate":
        const german = /^[A-Z]{3}[ -]?[A-Z0-9]{2}[ -]?[A-Z0-9]{3,6}$/i;
        if (!german.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;

      case "amount":
        const amount = /^\d+([.,]\d{1,2})?$/;
        if (!amount.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
      case "datetime":
      case "time":
        const date = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/;
        if (!date.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
      case "text":
        break;
      default:
        break;
    }
    if (field.type === "date" || field.type === "datetime") {
      if (field.greater) {
        const fieldValue = new Date(udpatedValue[field.greater]);
        const currentValue = new Date(value);

        // // Set time of date to 00:00
        // fieldValue.setHours(0, 0, 0, 0);
        // currentValue.setHours(0, 0, 0, 0);

        // const differenceInTime = currentValue.getTime() - fieldValue.getTime();
        // const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

        // if (differenceInDays < 1) {
        //   tempformError = t("validContent", { label: t(field.label) });
        //   flag += 1;
        // }
        if (fieldValue > currentValue) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
      }

      if (field.less) {
        const fieldValue = new Date(udpatedValue[field.less]);
        const currentValue = new Date(value);
        // const differenceInDays = Math.floor((fieldValue - currentValue) / (1000 * 60 * 60 * 24));
        // if (differenceInDays <= 1) {
        //   tempformError = t("validContent", { label: t(field.label) });
        //   flag += 1;
        // }
        if (fieldValue < currentValue) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
      }
    }
    if (field.type === "image" || field.type === "file") {
      if (value.length === 0) {
        tempformError = t("validContent", { label: t(field.label) });
        flag += 1;
      }
    } else {
      if (field.required && value?.length === 0) {
        tempformError = t("required", { label: t(field.label) });
        flag += 1;
      } else if (field.minimum > value?.length) {
        tempformError = t("requiredMinimum", { minimum: field.minimum, label: t(field.label) });

        flag += 1;
      } else if (field.maximum < value?.length) {
        tempformError = t("maxLimit", { maximum: field.maximum, label: t(field.label) });

        flag += 1;
      }
    }

    return { flag, tempformError };
  };

  const handleChange = (index, event, id) => {
    const field = formInput[id];
    const value = event.target.value;
    const values = { ...formValues,[field.name]: value }
    setFormValues(values);
    const valid = validation(formInput, values, formErrors, false, false, false, false);
  }
  
  const submitChange = async(event) => {
    event.preventDefault();
    
    if (validation(formInput, formValues, formErrors, false, false, false, false)) {
       try {
        props.setLoaderBox(true);
            await putData({ ...formValues }, `company/admin/${props.user.user.company}`, dispatch, navigate)
              .then((response) => {
                if (response.status === 200) {
                  props.setMessage({
                    type: 1,
                    content: t("caseDeadlinesUpdated"),
                    okay: "Okay",
                    onClose: () => {},
                    code: 200
                  });
                  props.setLoaderBox(false);
                } else if (response.status === 201) {
                  props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 201 });
                  props.setLoaderBox(false);
                } else {
                  props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 500 });
                  props.setLoaderBox(false);
                }
                props.setLoaderBox(false);
              })
              .catch((error) => {
                props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
                props.setLoaderBox(false);
              });
       } catch (error) {
         console.error("error while submitting the form", error);
       }
    }
  };

  return (
    <RowContainer className="list static">
      <Form
                  onSubmit={(event) => {
                    event.preventDefault();
                  }}
                  action="#"
                  method="POST"
                  className={`${props.login??""} ${props.plainForm ? "plain" : "popup"} `}
                >
                  {/* Looping the form input array for generating the dynamic form*/}
                  {formInput &&
                    formInput.map((item, index) => {
                      let dynamicClass = "";
                      if (item.condition) {
                        if (formValues[item.condition.item] === item.condition.if) {
                          dynamicClass = item.condition.then;
                        } else {
                          dynamicClass = item.condition.else;
                        }
                      }
                      return (
                          <FormInput index={0} animation={`sub-1`} placeholder={item.placeholder} key={`input` + index} id={index} formValues={formValues} error={formErrors[formInput[index].name]} value={formValues[formInput[index].name]} {...item} onChange={handleChange} />
                        )
                    })}

                    {/* <div style={{ display: "none" }}>
                      <FormInput disabled={submitDisabled} type="submit" name="submit" value={t(props.button ? props.button : "submit")} onChange={submitChange} login={props.login} />
                    </div> */}
                </Form>
                <Footer className={`center`}>
                    <FormInput disabled={submitDisabled} type="submit" name="submit" value={t(props.button ? props.button : "submit")} onChange={submitChange} />
                    {/* <FormInput type="close" value={t("cancel")} onChange={closeModal} /> */}
                </Footer>
    </RowContainer>
  );
};
// exporting the page with parent container layout..
export default Layout(CaseDeadlines);
